import { DHeading } from './Heading'
import { Spacer } from '@/components/elements/Spacer'
import { IrSiteMapLink } from '@/components/enlayouts/SiteMap/IrSiteMapLink'

export const Footer = () => (
  <div>
    <DHeading>IR Site Map</DHeading>
    <Spacer h={{ sp: 30, pc: 60 }} />
    <IrSiteMapLink />
  </div>
)
